var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66536 17.5V16.6875C2.66536 16.2625 2.85203 15.8625 3.1437 15.675C5.11537 14.4125 7.36703 13.75 9.66537 13.75C9.70037 13.75 9.7237 13.75 9.7587 13.7625C9.87537 12.8875 10.1087 12.05 10.447 11.2875C10.1904 11.2625 9.9337 11.25 9.66537 11.25C6.84203 11.25 4.20536 12.0875 1.9537 13.525C0.927031 14.175 0.332031 15.4 0.332031 16.6875V20H11.1354C10.6454 19.25 10.2604 18.4 10.0037 17.5H2.66536Z",
    fill: "#182C55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66667 10C12.245 10 14.3333 7.7625 14.3333 5C14.3333 2.2375 12.245 0 9.66667 0C7.08833 0 5 2.2375 5 5C5 7.7625 7.08833 10 9.66667 10ZM9.66667 2.5C10.95 2.5 12 3.625 12 5C12 6.375 10.95 7.5 9.66667 7.5C8.38333 7.5 7.33333 6.375 7.33333 5C7.33333 3.625 8.38333 2.5 9.66667 2.5Z",
    fill: "#182C55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 10H13.1667C12.5192 10 12.0058 10.5562 12.0058 11.25L12 18.75C12 19.4438 12.5192 20 13.1667 20H22.5C23.1475 20 23.6667 19.4438 23.6667 18.75V11.25C23.6667 10.5562 23.1475 10 22.5 10ZM21.9167 18.75H13.75C13.4292 18.75 13.1667 18.4688 13.1667 18.125V15H22.5V18.125C22.5 18.4688 22.2375 18.75 21.9167 18.75ZM22.5 12.5H13.1667V11.25H22.5V12.5Z",
    fill: "#182C55",
    stroke: "#182C55",
    strokeWidth: 0.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.20c480ae.svg";
export { ForwardRef as ReactComponent };